var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "mainWrapper" },
    [
      _c(
        "el-aside",
        { staticStyle: { padding: "0" }, attrs: { width: "0vw" } },
        [
          _c("drawer-aside", {
            attrs: { unfold: _vm.unfold },
            on: {
              unfoldMethod: function($event) {
                return _vm.fold($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("header-section", { on: { spread: _vm.spread } }),
          _vm._v(" "),
          _c("el-main", [
            _c(
              "div",
              { staticClass: "landing-page" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("img", {
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          "object-fit": "cover"
                        },
                        attrs: {
                          src: require("../../assets/advertise-with-us-banner.png"),
                          alt: "img"
                        }
                      })
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticClass: "title-txt-wrapper" }, [
                        _vm._v(
                          "\n              Welcome to an exclusive platform designed for brands, service providers, and businesses in the property market looking to reach an\n              active audience of homebuyers and investors interested in new developments and off-the-plan properties. By advertising with us, your\n              business will be placed in front of highly engaged buyers, ready to explore, invest, and purchase. With prominent ad placements,\n              insightful data, and tailored campaigns, we help you amplify your brand’s reach directly within the real estate journey.\n            "
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { staticClass: "benefits-section" },
                  [
                    _c("el-col", { attrs: { xs: 24, sm: 12 } }, [
                      _c("h2", [
                        _vm._v("U-Promote: Benefits of Advertising with Us")
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "benefits-list" }, [
                        _c("li", [
                          _c("h3", [_vm._v("Targeted Audience")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Reach buyers actively searching for new and off-the-plan properties, from first-time buyers to\n                  investors."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("h3", [_vm._v("High Visibility")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Take advantage of prominent ad placements across our platform for maximum exposure."
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("h3", [_vm._v("Engaged Audience")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Access a highly engaged audience.\n                  With the amount of information agents showcase on\n                  each property, users spend substantial time viewing our\n                  property platform."
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      {
                        staticClass: "benefits-image-container",
                        attrs: { xs: 24, sm: 12 }
                      },
                      [
                        _c("div", { staticClass: "benefits-image-wrapper" }, [
                          _c("img", {
                            staticClass: "benefits-image",
                            attrs: {
                              src: require("../../assets/advertise-mobile-image.png"),
                              alt: "Mobile app demonstration"
                            }
                          })
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "features-section" },
                  [
                    _c("h2", [
                      _vm._v(
                        "Agents:Showcase Your Properties to a Ready Market"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "features-intro" }, [
                      _vm._v(
                        "\n            As an agent, you know that off-the-plan and new property sales require clear, detailed listings to attract the right buyers. Our platform is\n            built for properties like yours, catering to those looking for off the plan properties and new homes, custom options, and efficient layouts.\n            Listing with us puts your properties in front of a targeted audience, ready to reserve and explore off-the-plan opportunities.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 40 } },
                      [
                        _c(
                          "el-col",
                          {
                            staticClass: "feature-image-container",
                            attrs: { span: 12 }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "feature-image-wrapper" },
                              [
                                _c("img", {
                                  staticClass: "feature-image",
                                  attrs: {
                                    src: require("../../assets/advertise-laptop-image.png"),
                                    alt: "Platform demonstration"
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("div", { staticClass: "feature-list" }, [
                            _c("h2", [_vm._v("Why List with Us?")]),
                            _vm._v(" "),
                            _c("ul", [
                              _c("li", [
                                _c("h3", [
                                  _vm._v("Detailed, Interactive Listings")
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Showcase floor plans, live pricing,\n                      and features buyers need to make informed decisions"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h3", [_vm._v("Online Reservation Option")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    ": Buyers can reserve a property with a\n                      small deposit, securing their interest and kickstarting the process.\n                      Helping you to sell property while you sleep. "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h3", [_vm._v("Dedicated Market Reach")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Be part of a specialised platform,\n                      attracting those looking specifically for new developments and brand-\n                      new property options."
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "contact-section" }, [
                  _c("p", [
                    _vm._v(
                      "Join us to connect with motivated buyers, enhance visibility, and grow your presence in the market. Advertise with us or list your\n            properties today to take your reach to the next level."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "contain-title" }, [
                    _vm._v(
                      " If you have any questions on partnering with our team, please contact us at: "
                    ),
                    _c(
                      "a",
                      { attrs: { href: "mailto:upromote@unifiproperty.com" } },
                      [_vm._v("upromote@unifiproperty.com")]
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "el-footer",
            { staticStyle: { padding: "0", height: "0" } },
            [_c("footer-section")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-384981b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-384981b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/advertiseWithUs/advertiseWithUsLayout.vue
// module id = null
// module chunks = 